"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextField = exports.Label = exports.Error = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _polished = require("polished");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Label = _styledComponents.default.label`
  ${({
  $error,
  $disabled,
  theme
}) => (0, _styledComponents.css)`
    position: relative;
    display: flex;
    flex-direction: column;
    color: ${$error ? theme.colors.error : theme.colors.white};
    font-family: ${theme.fonts.family.montserrat};
    font-size: ${theme.fonts.sizes.xsmall};
    width: 100%;

    ${$disabled && (0, _styledComponents.css)`
      pointer-events: none;
      opacity: .4;
    `}

    ::after {
      content: "";
      position: absolute;
      bottom: 0;
      width: 100%;
      border-bottom: .1rem solid ${theme.colors.input};
      transition: border-color .2s ease-in-out;
    }

    &:hover {
      ::after {
        border-color: ${(0, _polished.lighten)(.2, theme.colors.input)};
        border-width: .15rem;
      }
    }

     &:has(input:focus) {
      ::after {
        border-color: ${(0, _polished.lighten)(.4, theme.colors.input)};
        border-width: .15rem;
      }
    }

    ${$error && (0, _styledComponents.css)`
      &, &:hover, &:has(input:focus) {
        ::after {
          border-color: ${theme.colors.error};
        }
      }
    `}
  `}
`;
exports.Label = Label;
const TextField = _styledComponents.default.input`
  ${({
  theme
}) => (0, _styledComponents.css)`
    -moz-appearance: textfield;
    background: none;
    color: ${theme.colors.input};
    font-family: ${theme.fonts.family.montserrat};
    font-size: ${theme.fonts.sizes.xxlarge};
    width: 100%;
    line-height: 4.5rem;
    transition: color .2s ease-in-out;

    &::placeholder {
      color: ${theme.colors.input};
      opacity: 0.5;
    }

    &:hover {
      color: ${(0, _polished.lighten)(.2, theme.colors.input)};
    }

    &:focus {
      color: ${(0, _polished.lighten)(.4, theme.colors.input)};
    }
    
    &::-webkit-outer-spin-button, ::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  `}
`;
exports.TextField = TextField;
const Error = _styledComponents.default.p`
  ${({
  theme
}) => (0, _styledComponents.css)`
    color: ${theme.colors.error};
    font-family: ${theme.fonts.family.montserrat};
    font-size: ${theme.fonts.sizes.xsmall};
    line-height: 1;
    margin-top: .9rem;
    min-height: ${theme.fonts.sizes.xsmall};
  `}
`;
exports.Error = Error;